import * as React from 'react';
import isNil from 'lodash/isNil';

import SVGIcon from 'components/svg-icon/SVGIcon';
import LazyLoadImg from 'components/lazy-load-img/LazyLoadImg';
import MoreButton from 'components/buttons/more-button/MoreButton';
import { withContextMenu } from 'components/context-menu/ContextMenuHOC';
import { withModal } from 'components/modal/ModalHOC';

import { WITH_GALLERY_MODAL_CONFIG } from 'utils/gallery';
import { __t, applyTranslations } from 'utils/language';

import {
  GalleryModalItem,
  StorySnippet
} from 'types';

import './story-snippets-list.scss';

applyTranslations(require('./story-snippets-list.i18n.json'));

interface Props {
  snippets: Array<StorySnippet>,
  canDelete: boolean,
  onRemoveSnippet: (code: string) => void
}

const DivWithModal = withModal(<div />, WITH_GALLERY_MODAL_CONFIG);

const MoreButtonWithMenu = withContextMenu(MoreButton, {
  position: 'bottom',
  canEmpty: true
});

const StorySnippetsList = ({ snippets, canDelete, onRemoveSnippet }: Props): JSX.Element => {
  const modalItems: Array<GalleryModalItem> = snippets.map(s => ({
    id: s.code,
    type: !isNil(s.videoUrl) ? 'collabary-video' : 'cloudinary-image',
    assetUrl: s.imageUrl,
    url: s.videoUrl
  }));

  return (
    <div className="story-snippets-list">
      {snippets.map((s, i) => (
        <div
          key={s.code}
          className="story-snippets-list__item"
        >
          <DivWithModal
            modalContentProps={{
              items: modalItems,
              currentPosition: i
            }}
          >
            <div className="story-snippets-list__thumbnail">
              <LazyLoadImg
                className="story-snippets-list__image"
                src={s.imageUrl}
                alt={s.code}
              />
              {!isNil(s.videoUrl) ? (
                <div className="story-snippets-list__play-button">
                  <SVGIcon
                    name="play-button"
                    width={40}
                    height={40}
                  />
                </div>
              ) : null}
            </div>
          </DivWithModal>
          {canDelete ? (
            <div className="story-snippets-list__item-bottom-area">
              <div className="story-snippets-list__item-actions">
                <div>
                  <MoreButtonWithMenu
                    width={4}
                    contextMenuProps={{
                      items: [{
                        icon: 'trash-custom-fg',
                        text: __t('story_snippets_list.delete'),
                        onClick: () => onRemoveSnippet(s.code)
                      }]
                    }}
                    iconHeight={16}
                    iconWidth={6}
                  />
                </div>
              </div>
            </div>
          ) : null}
        </div>
      ))}
    </div>
  );
};

export default StorySnippetsList;
